import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Download } from 'lucide-react';
import styles from './MileageAnalysisTab_bus.module.css';
import Filter_Analysis from './Filter_Analysis';
import VehicleDetailsCard from './VehicleDetailsCard';
import FuelEfficiencyCard from './FuelEfficiencyCard';
import RunningHistoryCard from './RunningHistoryCard';
import DrivingBehaviorCard from './DrivingBehaviorCard';
import VehicleHealthCard from './VehicleHealthCard';
import MileageInsightsCard from './MileageInsightsCard';
import moment from 'moment';
import { useVehicleData } from './context';
import CustomSelectFilter_MA_BUS from './CustomSelectFitler_MA_Bus'
import DownloadDriverDetails from './DownloadDriverDetails';


const INIT_FILTER_STATE_ANALYSIS = {
  startDate: moment().subtract(7, 'days').format("YYYY-MM-DD"),
  endDate: moment().subtract(1, 'days').format("YYYY-MM-DD"),
  selectedVehicles: [],
  selectedRoute: ''
};


const CUSTOM_FILTER_ANALYSIS_STATE = {
  startDate: moment().subtract(7, 'days').format("YYYY-MM-DD"),
  endDate: moment().subtract(1, 'days').format("YYYY-MM-DD"),
  selectedVehicles: [],
  selectedRoute: ''
};

const tabs = [
  'Vehicle Details',
  'Running History',
  'Driving Behavior',
  'Vehicle Health Parameter',
];


const MileageAnalysisTab = () => {
  const { GlobalData, setGlobalData, handleDownloadAllReport } = useVehicleData();

  const [activeDefaultTab, setActiveDefaultTab] = useState('Vehicle Details');
  const [globalFilter, setGlobalFilter] = useState({ ...INIT_FILTER_STATE_ANALYSIS });
  const [customFilter, setCustomFilter] = useState({ ...CUSTOM_FILTER_ANALYSIS_STATE });
  const [bestDayDate, setBestDayDate] = useState('')
  const [benchmarkType, setBenchmarkType] = useState('Custom');
  const [isVehicleSelected, setIsVehicleSelected] = useState(false);
  const [selectedVehicleData, setSelectedVehicleData] = useState(null);


  useEffect(() => {
    setGlobalData(prev => ({
      ...prev,
      firstVin: selectedVehicleData?.firstVinNo,
      secondVin: selectedVehicleData?.secondVinNo,
      bestDayDate: bestDayDate,
      globalFilter: globalFilter,
      customFilter: customFilter
    }))
  }, [selectedVehicleData, globalFilter, customFilter], bestDayDate)


  const sectionRefs = useRef({
    'Vehicle Details': useRef(null),
    'Running History': useRef(null),
    'Driving Behavior': useRef(null),
    'Vehicle Health Parameter': useRef(null),
    'Energy Efficiency Related Fault Codes': useRef(null),
    'Mileage Insights': useRef(null),
    'Performance Enhancement Areas': useRef(null)
  });

  const filterSubmitted = useCallback((data) => {
    setGlobalFilter(data);
  }, []);

  const customFilterSubmitted = useCallback((data) => {
    setCustomFilter(data);
  }, []);

  const handleBenchmarkChange = (type) => {
    if ((type === 'National' || type === 'Fleet') && !isVehicleSelected) {
      return;
    }

    setBenchmarkType(type);
  };



  const handleVehicleSelect = (vehicleData) => {

    setSelectedVehicleData(vehicleData);

    setIsVehicleSelected(true);
  };


  const handleTabClick = (tabName) => {
    setActiveDefaultTab(tabName);

    if (selectedVehicleData && sectionRefs.current[tabName]?.current) {
      sectionRefs.current[tabName].current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  };

  const getSectionComponent = (tabName, vehicleData) => {
    switch (tabName) {
      case 'Vehicle Details':
        return <FuelEfficiencyCard benchmarkType={benchmarkType} selectedVehicleData={selectedVehicleData} globalFilter={globalFilter} customFilter={customFilter} setBestDayDate={setBestDayDate} />;
      case 'Running History':
        return <RunningHistoryCard benchmarkType={benchmarkType} selectedVehicleData={selectedVehicleData} globalFilter={globalFilter} customFilter={customFilter} />;
      case 'Driving Behavior':
        return <DrivingBehaviorCard benchmarkType={benchmarkType} selectedVehicleData={selectedVehicleData} globalFilter={globalFilter} customFilter={customFilter} />;
      case 'Vehicle Health Parameter':
        return <VehicleHealthCard /* vehicleData={vehicleData} */ benchmarkType={benchmarkType} selectedVehicleData={selectedVehicleData} globalFilter={globalFilter} customFilter={customFilter} />;
      // case 'Energy Efficiency Related Fault Codes':
      //   return <FuelEfficiencyFaultCodesCard /* vehicleData={vehicleData} */ benchmarkType={benchmarkType} selectedVehicleData={selectedVehicleData} globalFilter={globalFilter} customFilter={customFilter} />;
      default:
        return (
          <div className="text-center py-4">
            <p className={`text-muted ${styles.content_placeholder}`}>Content for {tabName} is being prepared...</p>
          </div>
        );
    }
  };

  const isBenchmarkTabDisabled = (type) => {
    return (type === 'National' || type === 'Fleet') && !isVehicleSelected;
  };

  const getBenchmarkTabClasses = (type) => {
    const baseClasses = `fw-bold px-3 py-1 ${styles.benchmark_tab}`;

    if (isBenchmarkTabDisabled(type)) {
      return `${baseClasses} ${styles.benchmark_tab_disabled}`;
    }

    if (benchmarkType === type) {
      return `${baseClasses} ${styles.benchmark_tab_active}`;
    }

    return `${baseClasses} ${styles.benchmark_tab_inactive}`;
  };

  const cityRouteFilterHandler = (data) => {

    setGlobalFilter(prev => ({ ...prev, ...data }))
    setCustomFilter(prev => ({ ...prev, ...data }))
  }

  return (
    // <VehicleDataProvider>
    <div className="container-fluid">
      {/* <VehicleDashboard /> */}
      {/* <DownloadDriverDetails speedValue={55} /> */}
      {/* <div className='card p-3 mb-4'>
        <CustomSelectFilter_MA_BUS setGlobalFilter={cityRouteFilterHandler} />
      </div> */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h6 className={`m-0 fw-bold ${styles.analysis_header}`}>
          Comparative Overview : Understanding Energy Efficiency Metrics
        </h6>
        <button
          className={`text-decoration-none ${styles.download_button} ${GlobalData?.primaryVehicleDetails?.vehicleId ? "" : 'text-muted'}`} style={{ pointerEvents: GlobalData?.primaryVehicleDetails?.vehicleId ? "" : "none" }}
          // className={`d-flex align-items-center gap-2 ${styles.download_button}`}
          onClick={() => handleDownloadAllReport(benchmarkType)}
        >
          <Download size={20} />
          <span>Download Report</span>
        </button>
      </div>

      {/* Tabs Section */}
      <div className={`p-3 rounded ${styles.tabs_container}`}>
        <div className={`d-flex gap-4 pb-1 ${styles.tabs_wrapper}`}>
          {tabs.map((tab) => (
            <h6
              key={tab}
              className={`m-0 fw-bold flex-shrink-0 ${styles.tab_item} ${activeDefaultTab === tab ? styles.tab_item_active : styles.tab_item_inactive
                }`}
              onClick={() => handleTabClick(tab)}
            >
              {tab}
            </h6>
          ))}
        </div>
      </div>

      <div className="mb-4">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="flex-grow-1 d-flex align-items-center">
            <h6 className={`m-0 fw-bold ${styles.selected_header}`}>Selected Vehicle</h6>
          </div>

          <div className="flex-grow-1 d-flex justify-content-center align-items-center">
            <i className={`fas fa-chart-bar me-2 ${styles.chart_icon}`}></i>
            <h6 className={`m-0 fw-bold ${styles.selected_header}`}>Selected Vehicle Best Driven Day</h6>
          </div>

          <div className="flex-grow-1 d-flex justify-content-end align-items-center gap-3">
            {['National', 'Fleet', 'Custom'].map((type) => (
              <span
                key={type}
                onClick={() => handleBenchmarkChange(type)}
                className={getBenchmarkTabClasses(type)}
                style={{
                  cursor: isBenchmarkTabDisabled(type) ? 'not-allowed' : 'pointer',
                  opacity: isBenchmarkTabDisabled(type) ? 0.5 : 1
                }}
                title={isBenchmarkTabDisabled(type) ? 'Please select a vehicle first' : ''}
              >
                {type}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Filter Section */}
      <div className="row">
        <div className={benchmarkType === 'Custom' ? 'col-md-6' : 'col-md-12'}>
          <div className="mb-3">
            <Filter_Analysis
              onsubmit={filterSubmitted}
              globalfilter={globalFilter}
              setGlobalfilter={setGlobalFilter}
              justifyContent="justify-content-left"

            />
          </div>
        </div>
        {benchmarkType === 'Custom' && (
          <div className="col-md-6">
            <div className="mb-3">
              <Filter_Analysis
                onsubmit={customFilterSubmitted}
                justifyContent="justify-content-end"
                globalfilter={customFilter}
                setGlobalfilter={setCustomFilter}
              />
            </div>
          </div>
        )}
      </div>

      {/* Filter Summary */}
      <div className="mb-3">
        <div className={`small ${styles.filter_summary}`}>
          <strong>Applied Filters:</strong>
          <span className="ms-2">
            <strong>Benchmark:</strong> {benchmarkType}
          </span>
          {globalFilter.startDate && globalFilter.endDate && (
            <span className="ms-2">
              📅 Primary: {moment(globalFilter.startDate).format('MMM D, YYYY')} - {moment(globalFilter.endDate).format('MMM D, YYYY')}
            </span>
          )}
          {globalFilter.selectedVehicles && globalFilter.selectedVehicles.length > 0 && (
            <span className="ms-2">
              🚗 Vehicles: {globalFilter.selectedVehicles.length} selected
            </span>
          )}
          {globalFilter.selectedFleet && (
            <span className="ms-2">
              🚛 Fleet: {globalFilter.selectedFleet.name}
            </span>
          )}
          {globalFilter.selectedRoute && (
            <span className="ms-2">
              🛣️ Route: {globalFilter.selectedRoute}
            </span>
          )}
          {benchmarkType === 'Custom' && customFilter.startDate && customFilter.endDate && (
            <span className="ms-2">
              📅 Custom: {moment(customFilter.startDate).format('MMM D, YYYY')} - {moment(customFilter.endDate).format('MMM D, YYYY')}
            </span>
          )}
        </div>
      </div>

      {/* Vehicle Details Card */}
      <VehicleDetailsCard
        selectedVehicles={globalFilter.selectedVehicles || []}
        // onAddVehicle={handleAddVehicle}
        filterData={globalFilter}
        bestDayDate={bestDayDate}
        onFilterChange={(newFilter) => {
          setGlobalFilter(newFilter);
          filterSubmitted(newFilter);
        }}
        onVehicleSelect={handleVehicleSelect}
        benchmarkType={benchmarkType}
      />

      {selectedVehicleData?.firstVinNo?.vehicleId && (
        <div className="row mt-4">
          <div className="col-12">
            {tabs.map((tab, index) => (
              <div
                key={tab}
                ref={sectionRefs.current[tab]}
                className={`p-3 px-4 rounded mb-4 ${tab === "Vehicle Details" ? "bg-white pt-0" : styles.section_container}`}
              >
                {getSectionComponent(tab, selectedVehicleData)}
              </div>
            ))}
          </div>
        </div>
      )}

      {selectedVehicleData && (
        <div className="row mt-4">
          <div className="col-12">
            <div
              ref={sectionRefs.current['Mileage Insights']}
              className={`p-4 rounded mb-4 ${styles.mileage_insights_container}`}
            >
              <MileageInsightsCard
                vehicleData={selectedVehicleData}
                filterData={globalFilter}
              />
            </div>
          </div>
        </div>
      )}

      {/* {selectedVehicleData && (
        <div className="row mt-4">
          <div className="col-12">
            <div
              ref={sectionRefs.current['Performance Enhancement Areas']}
              className={`p-4 rounded ${styles.waterfall_chart_container}`}
            >
              <WaterfallChartCard
                vehicleData={selectedVehicleData}
                filterData={globalFilter}
                benchmarkType={benchmarkType}
                selectedVehicleData={selectedVehicleData}
              />
            </div>
          </div>
        </div>
      )} */}
    </div>
    // </VehicleDataProvider>
  );
};

export default MileageAnalysisTab;